module.exports = __webpack_public_path__ + "media/audio18.f8005265.mp3";